// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transcript-container {
    padding: 20px;
    background: white;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow:hidden;
    position: relative;
  }
  
  .transcript-header {
    height: 10%;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 10px;
  }
  
  .transcript-actions {
    display: flex;
    gap: 12px;
  }
  
  .transcript-action-button {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: white;
    color: #374151;
    cursor: pointer;
    font-size: 14px;
  }

  .recording{
    background-color:#f37777 !important;
  }
  
  .transcript-action-button:hover {
    background: #edeff0;
  }
  
  .transcript-content {
    height: 65%;
    max-width: 100%;
    overflow-y: scroll;
    line-height: 1.5;
    color: #374151;
    font-size: 16px;
    padding:0px 16px;
  }
  
  .transcript-editor {
    width: 100%;
    height: 100%;
    min-height: 65%;
    padding: 16px;
    border: 1px solid #e5e7eb;
    font-size: 14px;
    line-height: 1.6;
    font-family: inherit;
    resize: none;
    color: #374151;
    background: white;
  }
  
  .transcript-editor:focus {
    outline: none;
  }

  .transcript-markdown-content {
    font-size: 14px;
    line-height: 1.6;
    color: #374151;
  }
  
  .transcript-markdown-content h1,
  .transcript-markdown-content h2,
  .transcript-markdown-content h3,
  .transcript-markdown-content h4,
  .transcript-markdown-content h5,
  .transcript-markdown-content h6 {
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    font-weight: 500;
    color: #111827;
  }
  
  .transcript-markdown-content p {
    margin: 1em 0;
  }
  
  .transcript-markdown-content ul,
  .transcript-markdown-content ol {
    margin: 1em 0;
    padding-left: 1.5em;
  }
  
  .transcript-markdown-content li {
    margin: 0.5em 0;
  }
  

  .audio-player {
    height: 15%;
    width: 100%;
    border-top: 1px solid #e5e7eb;
    padding-top: 16px;
    margin-bottom: 20px;
  }
  
  .audio-info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    color: #374151;
    font-size: 14px;
  }
  
  .recording-name {
    font-weight: 500;
  }
  
  .audio-controls {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
  .play-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #374151;
    padding: 8px;
    border-radius: 50%;
  }
  
  .play-button:hover {
    background: #f3f4f6;
  }
  
  .progress-bar-container {
    flex: 1 1;
    position: relative;
  }
  
  .progress-bar {
    width: 100%;
    height: 4px;
    appearance: none;
    background: #e5e7eb;
    border-radius: 2px;
    outline: none;
    cursor: pointer;
  }
  
  .progress-bar::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    background: #0d9488;
    border-radius: 50%;
    cursor: pointer;
  }
  
  .audio-actions {
    display: flex;
    gap: 8px;
  }
  
  .audio-action-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #374151;
    padding: 8px;
    border-radius: 50%;
  }
  
  .audio-action-button:hover {
    background: #f3f4f6;
  }
  
  
  @media (max-width: 600px) {
    .transcript-container {
      padding: 10px;
      overflow:auto;
    }
    .transcript-actions {
      padding-right: 20px;
    }
    .transcript-markdown-content {
      font-size: 14px;
      line-height: 1.4;
    }
    
  }
  `, "",{"version":3,"sources":["webpack://./src/components/selectedSessionComponent/TranscriptView.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;;;;;IAME,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,WAAW;IACX,WAAW;IACX,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,WAAW;IAEX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,eAAe;EACjB;;EAEA;IAEE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE;MACE,aAAa;MACb,aAAa;IACf;IACA;MACE,mBAAmB;IACrB;IACA;MACE,eAAe;MACf,gBAAgB;IAClB;;EAEF","sourcesContent":[".transcript-container {\n    padding: 20px;\n    background: white;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow:hidden;\n    position: relative;\n  }\n  \n  .transcript-header {\n    height: 10%;\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding-bottom: 10px;\n  }\n  \n  .transcript-actions {\n    display: flex;\n    gap: 12px;\n  }\n  \n  .transcript-action-button {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    background: white;\n    color: #374151;\n    cursor: pointer;\n    font-size: 14px;\n  }\n\n  .recording{\n    background-color:#f37777 !important;\n  }\n  \n  .transcript-action-button:hover {\n    background: #edeff0;\n  }\n  \n  .transcript-content {\n    height: 65%;\n    max-width: 100%;\n    overflow-y: scroll;\n    line-height: 1.5;\n    color: #374151;\n    font-size: 16px;\n    padding:0px 16px;\n  }\n  \n  .transcript-editor {\n    width: 100%;\n    height: 100%;\n    min-height: 65%;\n    padding: 16px;\n    border: 1px solid #e5e7eb;\n    font-size: 14px;\n    line-height: 1.6;\n    font-family: inherit;\n    resize: none;\n    color: #374151;\n    background: white;\n  }\n  \n  .transcript-editor:focus {\n    outline: none;\n  }\n\n  .transcript-markdown-content {\n    font-size: 14px;\n    line-height: 1.6;\n    color: #374151;\n  }\n  \n  .transcript-markdown-content h1,\n  .transcript-markdown-content h2,\n  .transcript-markdown-content h3,\n  .transcript-markdown-content h4,\n  .transcript-markdown-content h5,\n  .transcript-markdown-content h6 {\n    margin-top: 1.5em;\n    margin-bottom: 0.5em;\n    font-weight: 500;\n    color: #111827;\n  }\n  \n  .transcript-markdown-content p {\n    margin: 1em 0;\n  }\n  \n  .transcript-markdown-content ul,\n  .transcript-markdown-content ol {\n    margin: 1em 0;\n    padding-left: 1.5em;\n  }\n  \n  .transcript-markdown-content li {\n    margin: 0.5em 0;\n  }\n  \n\n  .audio-player {\n    height: 15%;\n    width: 100%;\n    border-top: 1px solid #e5e7eb;\n    padding-top: 16px;\n    margin-bottom: 20px;\n  }\n  \n  .audio-info {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n    color: #374151;\n    font-size: 14px;\n  }\n  \n  .recording-name {\n    font-weight: 500;\n  }\n  \n  .audio-controls {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n  \n  .play-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #374151;\n    padding: 8px;\n    border-radius: 50%;\n  }\n  \n  .play-button:hover {\n    background: #f3f4f6;\n  }\n  \n  .progress-bar-container {\n    flex: 1;\n    position: relative;\n  }\n  \n  .progress-bar {\n    width: 100%;\n    height: 4px;\n    -webkit-appearance: none;\n    appearance: none;\n    background: #e5e7eb;\n    border-radius: 2px;\n    outline: none;\n    cursor: pointer;\n  }\n  \n  .progress-bar::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 12px;\n    height: 12px;\n    background: #0d9488;\n    border-radius: 50%;\n    cursor: pointer;\n  }\n  \n  .audio-actions {\n    display: flex;\n    gap: 8px;\n  }\n  \n  .audio-action-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #374151;\n    padding: 8px;\n    border-radius: 50%;\n  }\n  \n  .audio-action-button:hover {\n    background: #f3f4f6;\n  }\n  \n  \n  @media (max-width: 600px) {\n    .transcript-container {\n      padding: 10px;\n      overflow:auto;\n    }\n    .transcript-actions {\n      padding-right: 20px;\n    }\n    .transcript-markdown-content {\n      font-size: 14px;\n      line-height: 1.4;\n    }\n    \n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
